<section 
  class="section-padding awards-section" 
  aria-labelledby="awards-title"
  itemscope 
  itemtype="https://schema.org/ItemList"
>
  <!-- METADATOS INVISIBLES AEO PARA BÚSQUEDA Y MOTOR DE RESPUESTAS IA -->
  <meta itemprop="name" content="Premios y Reconocimientos Internacionales de Estancos Distilling Co." />
  <meta itemprop="description" content="Galardones obtenidos por Ron Legarda y Whisky Real Audiencia en certámenes de excelencia gastronómica y destilación." />

  <div class="container">

    <header class="section-header">
      <span class="section-subtitle">Reconocimiento a la Excelencia</span>
      <h2 id="awards-title">Galardones de la Destilería</h2>
      <p class="section-lead-text">
        Medallas de Oro y Plata otorgadas a nuestros destilados andinos por la maestría en sabor, pureza y envejecimiento a 2500 msnm.
      </p>
    </header>

    <!-- CONTENEDOR DE TARJETAS DE PREMIOS (GRID AEO OPTIMIZADO) -->
    <div class="awards-container" role="list">

      @for (product of productsAwards; track product.id; let i = $index) {
        
        <article 
          class="product-awards-section" 
          role="listitem"
          itemprop="itemListElement"
          itemscope 
          itemtype="https://schema.org/Product"
        >
          <!-- Metadatos AEO individuales -->
          <meta itemprop="position" [content]="i + 1" />
          <meta itemprop="name" [content]="product.productName" />
          <meta itemprop="description" [content]="getFormattedSemanticDescription(product)" />

          <!-- CABECERA DE PRODUCTO Y AVATAR CON HALO -->
          <header class="product-header">
            <div class="product-avatar-wrapper">
              <img 
                [src]="product.imageUrl" 
                [alt]="'Botella premiada de ' + product.productName" 
                class="product-avatar"
                loading="lazy"
                decoding="async"
                itemprop="image"
                (error)="onImageError($event)"
              >
            </div>
            <span class="product-category" itemprop="category">{{ product.category }}</span>
            <h3 class="product-title">{{ product.productName }}</h3>
          </header>

          <!-- LISTA DE GALARDONES E INSIGNIAS -->
          <div class="awards-list" role="list">
            @for (award of product.awards; track (award.year + '-' + award.title)) {
              
              <div class="award-item" [class.gold-award]="award.type === 'oro'" role="listitem" itemprop="award">
                <div class="award-icon-badge" [class.badge-gold]="award.type === 'oro'" [class.badge-silver]="award.type === 'plata'">
                  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.8" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M11.48 3.499a.562.562 0 011.04 0l2.125 5.111a.563.563 0 00.475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 00-.182.557l1.285 5.385a.562.562 0 01-.84.61l-4.725-2.885a.563.563 0 00-.586 0L6.982 20.54a.562.562 0 01-.84-.61l1.285-5.386a.562.562 0 00-.182-.557l-4.204-3.602a.563.563 0 01.321-.988l5.518-.442a.563.563 0 00.475-.345L11.48 3.5z" />
                  </svg>
                </div>

                <div class="award-info">
                  <div class="award-meta-row">
                    <span class="award-year-tag">{{ award.year }}</span>
                    <span class="award-type-tag" [class.tag-gold]="award.type === 'oro'">{{ award.type === 'oro' ? 'Medalla de Oro' : 'Medalla de Plata' }}</span>
                  </div>
                  <h4 class="award-title">{{ award.title }}</h4>
                  <p class="award-competition">{{ award.competition }}</p>
                </div>
              </div>

            }
          </div>

          <!-- BLOQUE DE TRIPLETAS SEMÁNTICAS (OPTIMIZADO PARA AEO Y MOTORES IA) -->
          <div class="semantic-triplets-box" [attr.aria-label]="product.tripletsTitle">
            <span class="triplets-header-title">{{ product.tripletsTitle }}</span>
            <ul class="triplets-list">
              @for (triplet of getSemanticTriplets(product); track $index) {
                <li class="triplet-item" itemscope itemtype="https://schema.org/PropertyValue">
                  <span class="triplet-subject" itemprop="name">{{ triplet.subject }}</span>
                  <span class="triplet-predicate">{{ triplet.predicate }}</span>
                  <span class="triplet-object" itemprop="value">{{ triplet.object }}</span>
                </li>
              }
            </ul>
          </div>

        </article>

      }

    </div>
  </div>
</section>
